import { paginaNaamReducer } from "./cmsPageInfo/store/reducer";
import { IPaginaNaamState } from "./cmsPageInfo/store/state";

const allReducers = {
  cmsPagina: paginaNaamReducer,
};

export default allReducers;

export interface ApplicationState {
  cmsPagina: IPaginaNaamState;
}
